import { useEffect } from "react";
import digitConverter from "../../../utils/digitConverter";
import thConverter from "../../../utils/thConverter";

const TajweedLBRow = ({ merit, student, setMyPosition, mySn, level }) => {
  useEffect(() => {
    if (student.sn === mySn) {
      setMyPosition(merit + 1);
    }
  }, [student.sn, mySn, merit, setMyPosition, level]);

  return (
    <tr className=" ">
      <th className="bg-green-100 font-bold">
        {digitConverter(merit + 1)} <sup>{thConverter(merit + 1)}</sup>
      </th>
      <th>{student?.sn}</th>
      <td>{student?.name.toUpperCase()}</td>

      <>
        <th>{student?.[`tajweed${level}data`]?.[0]?.Score}</th>
        <th>{student?.[`tajweed${level}data`]?.[1]?.Score}</th>
        <th>{student?.[`tajweed${level}data`]?.[2]?.Score}</th>
        <th className="bg-red-100 text-red-600">
          {student?.[`tajweed${level}Total`]}
        </th>
      </>
    </tr>
  );
};

export default TajweedLBRow;
